import {Button, TextField} from "@mui/material";
import FunctionsData from "../Functions/FunctionsData";
import {useEffect, useState} from "react";
const queryString = require('query-string');

/*
	Landing page for finance successful verification
 */
export default function FinanceSuccess() {

	const parsed = queryString.parse(window.location.search);
	sessionStorage.setItem('tkn', parsed.cidr);
	const [merco,setMerco] = useState('');
	const [email,setEmail] = useState('');
	const [done,setDone] = useState(false);

	const [vet,setVet] = useState([]);
	const [loading,setLoading] = useState(false);

	useEffect(() => {

		console.log(parsed)

		fetch(FunctionsData.getApiUrl('/api/register/vet/')+ parsed.cid, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': parsed.cidrx,
			}
		})
			.then((res) => {
				return res.json()
			})
			.then((d) => {
				console.log(FunctionsData.getApiUrl('/api/vet/')+parsed.cid, d);
				setVet(d.data);
				setLoading(false);
			});

	}, []);

	function markDone() {
		fetch(FunctionsData.getApiUrl('/api/register/finance-verify-ok'), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': parsed.cidrx,
			},
			body: JSON.stringify(
				{
					lnk:parsed.cidr,
					id:parsed.id,
					cid:parsed.cid,
					finance_processed_email:email,
					finance_merco_id:merco
				}
			)
		})
			.then((res) => {
				if(res.ok)
					return res.json()
			})
			.then((d) => {
				setDone(true);
				console.log(d);
			});
	}

	function isEmail(val) {
		let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!regEmail.test(val)) {
			return false;
		}
		return true;
	}

	if(loading === true) return null;

	if(done === true) return (
		<div style={{padding:40}}>
			<div>
				<img
					src="https://workvision.sgp1.digitaloceanspaces.com/spca/snipnchip_logo.png"
					style={{width:200, margin: '20px 0'}}
				/>
			</div>
			<h1>Thank you. You can close this window now.</h1>
		</div>
	)
	if(!vet) return "Link not valid";
	return (
		<div style={{padding:40}}>
			<div>
				<img
					src="https://workvision.sgp1.digitaloceanspaces.com/spca/snipnchip_logo.png"
					style={{width:200, margin: '20px 0'}}
				/>
			</div>
			<h1>Finish vet onboarding</h1>
			<div style={{paddingTop:20}}>
				<ul style={{marginLeft:40}}>
					<li><strong>Vet:</strong> {vet.business_name}</li>
					<li><strong>Address:</strong> {vet.formatted_address}</li>
					<li><strong>Email:</strong> {vet.email}</li>
				</ul>
			</div>
			<div style={{paddingTop:20}}>
				<TextField label={"Merco ID"} value={merco}
				           type={"text"}
				           error={(merco === '')}
				           onChange={(e) => {
					           setMerco(e.target.value.replace(/[^0-9.]/g,''))
				           }} />
			</div>
			<div style={{paddingTop:20}}>
				<TextField label={"Your email"} value={email}
				           type={"text"}
				           error={(!isEmail(email))}
				           onChange={(e) => {
					           setEmail(e.target.value)
				           }} />
			</div>
			<div style={{paddingTop:20}}>
				<Button variant={"contained"} disabled={(merco === '' || !isEmail(email))} onClick={markDone} >Submit to the Snip'n'chip team</Button>
			</div>
		</div>
	)
}
